<template>
	<div>
		<navh />

		<top :image="$route.fullPath.substr(0,6)==='/'" />

		<main>
			<router-view />
		</main>

		<foot />
	</div>
</template>
<style lang="scss">
	@import '../src/assets/less/app.scss';

	body{
		color:#2f2752;
		font-size: 18px;
		@include media-breakpoint-down(sm) {
			font-size: 14px;
		}
	}
	main{
		min-height: 50vh;
	}
	h1,
	h2,
	h3,
	h4{
		color: $tertiary-color;
	}
	h2{
		font-weight: 600;
	}
	.alert{
		margin-bottom: 0;
	}
	img{
		@extend .no-ui;
	}

	.btns{
		margin: -0.5vh -0.5vw;
		/*<!--margin: -5px;-->*/
		/*<!--margin: -5px;-->*/
		.btn{
			margin: 0.5vh 0.5vw;
			i{
				width: 25px;
				text-align: left;
				display: inline-block;
			}
		}
	}

	.mb-1vh{
		margin-bottom:1vh;
	}
	.mb-2vh{
		margin-bottom:2vh;
	}
	a:hover,
	a:focus{
		text-decoration: none;
	}

	.home{
		background-image: url('/img/bg.jpg');
		background-repeat: no-repeat;
		background-position: center center;
		background-attachment: fixed;
		background-size: cover;
		position: relative;
		z-index: 1;
		&:after{
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			content: "";
			z-index: -1;
			background: -webkit-linear-gradient(150deg, rgba(40, 20, 131, 0.76) 15%, rgba(143, 110, 213, 0.89) 70%, rgba(215, 130, 217, 0.74) 94%);
			background: -moz-linear-gradient(150deg, rgba(40, 20, 131, 0.76) 15%, rgba(143, 110, 213, 0.89) 70%, rgba(215, 130, 217, 0.74) 94%);
			background: -ms-linear-gradient(150deg, rgba(40, 20, 131, 0.76) 15%, rgba(143, 110, 213, 0.89) 70%, rgba(215, 130, 217, 0.74) 94%);
			background: -o-linear-gradient(150deg, rgba(40, 20, 131, 0.76) 15%, rgba(143, 110, 213, 0.89) 70%, rgba(215, 130, 217, 0.74) 94%);
			background: linear-gradient(150deg, rgba(40, 20, 131, 0.76) 15%, rgba(143, 110, 213, 0.89) 70%, rgba(215, 130, 217, 0.74) 94%);
		}
	}

	/*.hero{*/
	/*	padding-top: 5vh;*/
	/*	ul{*/
	/*		text-align: center;*/
	/*		li{*/
	/*			span{*/
	/*				font-size: 1.5em;*/
	/*			}*/
	/*		}*/
	/*	}*/
	/*}*/

	.item {
		.txt,
		.imgflex{
			display: flex;
			flex-direction: column;
			&:before,
			&:after{
				content: '';
				flex-grow: 1;
			}
			picture{
				margin: auto;
			}
		}
		h3 {
			font-size: 1.27em;
			line-height: 1.21em;
			color: #767676;
			font-weight: 100;
			margin: 0;
		}
		h2 {
			margin:0;
			font-size: 2.22em;
			line-height: 1.25em;
			color: #373737;
		}
		p{
			margin: 1vh 0 3vh;
			line-height: 1.6em;
			color: #555555;
		}
		p:last-child{
			margin-bottom: 0;
		}
		picture{
			&:not(.xs){
				display: block;
				@include media-breakpoint-down(sm) {
					display: none;
				}
			}
			&.xs{
				display: none;
				@include media-breakpoint-down(sm) {
					display: block;
				}
			}
		}
		>div:first-child{
			picture {
				padding-right: 2vw;
				@include media-breakpoint-down(sm) {
					padding-right: 0;
				}
			}
		}
		>div:last-child{
			picture {
				padding-left: 2vw;
				@include media-breakpoint-down(sm) {
					padding-left: 0;
				}
			}
		}
	}

	section{
		padding: 12vh 0 15vh;
		@include smartphones() {
			padding: 10vh 0;
		}
	}
	.bg1{
		background: #f8f9fa;
		.item{
			h3 {
				color: #727272;
			}
		}
	}

	.row.col-reverse{
		@include media-breakpoint-down(sm) {
			flex-direction: column-reverse;
		}
	}

</style>
<script>
	export default{
		name: 'app',
		metaInfo: {
			// Children can override the title.
			title: 'Gérez votre copropriété en toute simplicité !',
			titleTemplate: '%s - CoproPrivée',
			// Result: My Page Title ← My Site
			// If a child changes the title to "My Other Page Title",
			// it will become: My Other Page Title ← My Site
			// titleTemplate: '%s',
			// Define meta tags here.

			// title: "L'application",
			// meta: [
			// 	{name: 'description', content: 'Avec CoproPrivée, les syndics bénévoles, conseillers syndicaux, copropriétaires accèdent aux informations et documents les concernants grâce à une simple connexion internet.', id: 'desc'},
			// ]

			meta: [
				// {name: 'description', content: 'Gérez votre copropriété en toute simplicité ! Syndic bénévole, Copropriétaire ? Ce logiciel vous est destiné.', id: 'desc'},
				{name: 'description', content: "Syndic bénévole, Copropriétaire ? Adoptez facilement une gestion autonome pour valoriser votre immeuble, impliquer les copropriétaires, réduir les charges.", id: 'desc'},
				// Maîtrisez facilement la gestion (comptabilité, administratif) comme un pro !
				{ name: 'application-name', content: 'CoproPrivée' },
 				{ name: 'author', content: 'CoproPrivée' },

				// OpenGraph data (Most widely used)
				{property: 'og:title', content: 'Logiciel de gestion de copropriété.'},
				{property: 'og:site_name', content: 'CoproPrivée'},
				// The list of types is available here: http://ogp.me/#types
				{property: 'og:type', content: 'website'},
				// Should the the same as your canonical link, see below.
				{property: 'og:url', content: 'https://www.coproprivee.fr/'},
				{property: 'og:image', content: 'https://www.coproprivee.fr/img/coproprivee.png'},
				// Often the same as your meta description, but not always.
				{property: 'og:description', content: 'Simplifiez la gestion de votre copropriété. Syndic bénévole, Copropriétaire ? Ce logiciel vous est destiné.'},

				// Facebook / Open Graph
				// { property: 'fb:app_id', content: '123456789' },

				// Twitter card
				{name: 'twitter:card', content: 'summary'},
				{name: 'twitter:site', content: 'https://www.coproprivee.fr/'},
				{name: 'twitter:title', content: 'Logiciel de gestion en copropriété.'},
				{name: 'twitter:description', content: 'Simplifiez la gestion de votre copropriété. Syndic bénévole, Copropriétaire ? Ce logiciel vous est destiné.'},
				// Your twitter handle, if you have one.
				{name: 'twitter:creator', content: '@CoproPrivee'},
				{name: 'twitter:image:src', content: 'https://www.coproprivee.fr/img/coproprivee.png'},

				// Google / Schema.org markup:
				{itemprop: 'name', content: 'Logiciel de gestion en copropriété.'},
				{property: 'description', content: 'Simplifiez la gestion de votre copropriété. Syndic bénévole, Copropriétaire ? Ce logiciel vous est destiné.'},

				{itemprop: 'image', content: 'https://www.coproprivee.fr/img/coproprivee.png'}
			]
		},
		data: function() {
			return {
				nav:{},
				nav_vertical:{
					items:[],
					user:false
				},
				datas:[],
			}
		},
	}
</script>
